'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  25% {\n    background-color: ', ';\n  }\n  75% {\n    background-color: ', ';\n  }\n'], ['\n  25% {\n    background-color: ', ';\n  }\n  75% {\n    background-color: ', ';\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  0%, 100% {\n    transform: translateY(0);\n  }\n\n  25% {\n    transform: translateY(.25em);\n  }\n\n  50% {\n    transform: translateY(0);\n  }\n\n  75% {\n    transform: translateY(-.25em);\n  }\n'], ['\n  0%, 100% {\n    transform: translateY(0);\n  }\n\n  25% {\n    transform: translateY(.25em);\n  }\n\n  50% {\n    transform: translateY(0);\n  }\n\n  75% {\n    transform: translateY(-.25em);\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    0%, 100% {\n      top: 0;\n    }\n\n    25% {\n      top: .25em;\n    }\n\n    50% {\n      top: 0\n    }\n\n    75% {\n      top: -.25em;\n    }\n  '], ['\n    0%, 100% {\n      top: 0;\n    }\n\n    25% {\n      top: .25em;\n    }\n\n    50% {\n      top: 0\n    }\n\n    75% {\n      top: -.25em;\n    }\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n  position: relative;\n  background-color: currentColor;\n  color: ', ';\n  border-radius: 50%;\n  height: 1em;\n  width: 1em;\n  animation: ', ', ', ';\n  animation-duration: 1s;\n  animation-timing-function: linear;\n  animation-iteration-count: infinite;\n\n  &:not(:last-child) {\n    margin-right: 0.75em;\n  }\n  &:nth-child(2) {\n    animation-delay: -0.66s;\n  }\n  &:nth-child(3) {\n    animation-delay: -0.33s;\n  }\n'], ['\n  position: relative;\n  background-color: currentColor;\n  color: ', ';\n  border-radius: 50%;\n  height: 1em;\n  width: 1em;\n  animation: ', ', ', ';\n  animation-duration: 1s;\n  animation-timing-function: linear;\n  animation-iteration-count: infinite;\n\n  &:not(:last-child) {\n    margin-right: 0.75em;\n  }\n  &:nth-child(2) {\n    animation-delay: -0.66s;\n  }\n  &:nth-child(3) {\n    animation-delay: -0.33s;\n  }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 1.25em;\n  width: 4.5em;\n  ', ';\n'], ['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 1.25em;\n  width: 4.5em;\n  ', ';\n']);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _theme = require('HubStyleTokens/theme');

var _lazyEval = require('../utils/lazyEval');

var _lazyEval2 = _interopRequireDefault(_lazyEval);

var _BrowserTest = require('../utils/BrowserTest');

var _createLazyPropType = require('../utils/propTypes/createLazyPropType');

var _createLazyPropType2 = _interopRequireDefault(_createLazyPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var loadingColorAnimation = (0, _styledComponents.keyframes)(_templateObject, _theme.LOADING_INACTIVE_COLOR, _theme.LOADING_INACTIVE_COLOR);

var loadingAnimation = (0, _styledComponents.keyframes)(_templateObject2);

if ((0, _BrowserTest.isIE11)()) {
  // Fix for #5734
  loadingAnimation = (0, _styledComponents.keyframes)(_templateObject3);
}

var Dot = _styledComponents2.default.div.withConfig({
  displayName: 'UILoadingDots__Dot'
})(_templateObject4, _theme.LOADING_DEFAULT_COLOR, loadingAnimation, loadingColorAnimation);

var LoadingDots = _styledComponents2.default.div.withConfig({
  displayName: 'UILoadingDots__LoadingDots'
})(_templateObject5, function (props) {
  return props.grow && 'width: 100%; height: 100%;';
});

var warnForProps = function warnForProps(props) {
  if (props.use || props.color) {
    _devLogger2.default.warn({
      message: '[UILoadingDots]: the `use` and `color` props have been removed.',
      key: 'UILoadingDots - calypso only',
      url: 'https://git.hubteam.com/HubSpot/UIComponents/issues/6039'
    });
  }
};

var getTranslatedTitle = function getTranslatedTitle() {
  return _I18n2.default.fired && _I18n2.default.fired.ready ? _I18n2.default.text('salesUI.UILoading.title') : '';
};

var getClassName = function getClassName(className, grow) {
  return (0, _classNames2.default)(className, 'uiLoading', { 'uiLoading-grow': grow });
};

var getStyle = function getStyle(minHeight, style) {
  return minHeight ? _extends({}, style, { minHeight: minHeight }) : style;
};

exports.default = _react2.default.createClass({
  displayName: 'UILoadingDots',

  propTypes: {
    grow: _react.PropTypes.bool.isRequired,
    minHeight: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
    title: (0, _createLazyPropType2.default)(_react.PropTypes.string).isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      grow: true,
      title: getTranslatedTitle
    };
  },
  render: function render() {
    var _props = this.props,
        className = _props.className,
        __color = _props.color,
        grow = _props.grow,
        minHeight = _props.minHeight,
        style = _props.style,
        title = _props.title,
        __use = _props.use,
        rest = _objectWithoutProperties(_props, ['className', 'color', 'grow', 'minHeight', 'style', 'title', 'use']);

    warnForProps(this.props);

    return _react2.default.createElement(
      LoadingDots,
      _extends({
        className: getClassName(className, grow),
        'data-loading': true,
        style: getStyle(minHeight, style),
        title: (0, _lazyEval2.default)(title),
        grow: grow
      }, rest),
      _react2.default.createElement(Dot, { className: 'uiLoadingDot dot-1' }),
      _react2.default.createElement(Dot, { className: 'uiLoadingDot dot-2' }),
      _react2.default.createElement(Dot, { className: 'uiLoadingDot dot-3' })
    );
  }
});
module.exports = exports['default'];